var _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 2h18.1818v20h-18.1818z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.8208 20.4405-.0001-.0001-5.0333-5.2345c1.2785-1.3166 2.0675-3.1118 2.0675-5.0881 0-4.0303-3.2784-7.30871-7.3087-7.30871-4.03033 0-7.30874 3.27841-7.30874 7.30871 0 4.0304 3.27841 7.3088 7.30874 7.3088 1.7358 0 3.3316-.6089 4.5863-1.6229l5.0489 5.2509c.0871.0911.2036.1363.3197.1363.1108 0 .2213-.0413.3071-.1236l.0002-.0001c.1764-.1698.1817-.4503.0124-.6267zm-10.2746-3.9005c-3.54124 0-6.42219-2.8809-6.42219-6.4222 0-3.54121 2.88095-6.42216 6.42219-6.42216 3.5413 0 6.4222 2.88095 6.4222 6.42216 0 3.5413-2.8813 6.4222-6.4222 6.4222z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.153a300a7392c2e9edb6f4c02014fd89.svg";
export { ForwardRef as ReactComponent };